import $ from "jquery";

export function initParkingRequest() {
    function getUrlLang() {
        const params = new URLSearchParams(window.location.search);
        return params.get('lang') || 'de';
    }

    function postInNewTab(data) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://book.airport-weeze.com/book/NRN/Parking";
        form.target = "_blank";

        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    $(document).on("click", "span.button_parking, span.fs__button--parking--search", (e) => {
        const $closest = $(e.currentTarget).closest('.fs__parking, .parking');

        const entryDate = $closest.find('.parking__date--in .datepicker_value').html().split(".").join(".");
        const entryTime = $closest.find('select.parking__time--in').val();
        const exitDate = $closest.find('.parking__date--out .datepicker_value').html().split(".").join(".");
        const exitTime = $closest.find('select.parking__time--out').val();
        const lang = getUrlLang();

        const postData = {
            parkingDetailsSubmitted: "1",
            progressToNextStep: "1",
            entryDate: entryDate,
            entryTime: entryTime,
            exitDate: exitDate,
            exitTime: exitTime,
            lang: lang,
            terminalid: "0",
            promocodes: ""
        };

        console.log("Submitting parking request", postData);
        postInNewTab(postData);

        return false;
    });
}

